// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1iFfi","buttons":"PendingPaymentAlert_buttons__xBz77"};